import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { IExam, IExamCategory, IExamQuestionOptions, IExamQuestions } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { Location } from '@angular/common';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { el } from 'date-fns/locale';

@Component({
  selector: 'app-update-saq-answers',
  templateUrl: './update-saq-answers.component.html',
  styleUrls: ['./update-saq-answers.component.scss']
})
export class UpdateSaqAnswersComponent implements OnInit, OnChanges {
  textDisplay = 'Update SAQ Answers';

  exam: IExam = examDefault;

  modelError = '';
  categoryList: IExamCategory[] = [];
  question: IExamQuestions = {
    examinationQuestionID: 0,
    examinationID: 0,
    questionNumber: 0,
    questionType: '',
    questionHtml: '',
    marks: 0,
    penaltyMarks: 0,
    disabled: false,
    options: [],
    category: '',
    saqPossibleAnsers: '',
    language: '',
    maxWordCount: 0,
    languageEnum: '',
    compulsory: false,
    duration: 0,
    useCustomDuration: false,
    essaySubQuestions: []
  };
  @Input() selectedQuestion = {} as IExamQuestions;
  languages: any = [{ lang: 'English', code: 'en' }, { lang: 'Français', code: 'fr' }, { lang: 'Not Set', code: 'NotSet' }];

  changeMade = false;

  constructor(private examService: ExamService, private snackBar: SnackbarService,
    private actRoute: ActivatedRoute, private _location: Location, private cdr: ChangeDetectorRef) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];

      await this.examService.getExamCategories(this.exam.id).then((categories: any) => {
        this.categoryList = categories;
      });

      this.actRoute.paramMap.subscribe(params => {
        this.question.examinationQuestionID = JSON.parse(params.get("questionid")) as number ?? 0;
        if (this.question.examinationQuestionID !== 0 && this.question.examinationQuestionID !== null) {
          this.textDisplay = 'Update SAQ Answers';

        } else {

        }
      });
      await this.getQuestionDetails();
    }
  }


  async saveQuestion(update: boolean = false) {
    this.question.questionType = GetQuestionType(this.exam.examinationTypeenum);
    this.validateModel();
    if (this.modelError !== '') {
      window.document.getElementById("modelError").focus();
      window.document.getElementById("modelError").blur();
      return
    }
    this.question.examinationID = this.exam.id;
    try {
      if (update) {
        this.question.options = []
        await this.examService.updateQuestion(this.question);
        this.snackBar.success('SAQ Answers Updated SUCCESSFULLY!!');
      }
      this.examService.reloadGrid.next(true);
      this.changeMade = false;
    } catch (error) {
      console.log(error);
    }

  }

  validateModel() {
    // this.question.options = this.question.options.filter(q => q.optionHtml !== '');

    this.modelError = ''
    if (this.question.questionHtml == '') {
      this.modelError += "\n*Question required \n"
    }
    if (this.question.marks == 0) {
      this.modelError += "\n*Marks required \n"
    }
    if (this.question.questionType == '') {
      this.modelError += "\n*Question Type required \n"
    }
  }
  async ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedQuestion'] && changes['selectedQuestion'].currentValue) {
      this.question = { ...changes['selectedQuestion'].currentValue };
      if (this.question.examinationQuestionID) {
        //this.textDisplay = 'Update Question';
        //this.isSave = false;
        await this.getQuestionDetails();
      } else {
        //this.textDisplay = 'Add New Question';
        //this.isSave = true;
      }

    }
    this.cdr.detectChanges();
    console.log(this.question, "Q");

  }
  async getQuestionDetails() {
    if (this.question.examinationQuestionID !== 0) {
      await this.examService.getSaqQuestionWithUniqueAns(this.question.examinationQuestionID).then((q: any) => {
        this.question = q;
        if (this.question.questionType === "Short Answer Question") {
          this.question.questionType = "SAQ"
        }
        this.question.language = this.question.languageEnum

        // console.log(this.question, "Question details");
      })
    }
  }
  cancel() {
    this._location.back();
  }

  updateSaqPossibleAnswers() {
    this.changeMade = true;
    const checkedAnswers = this.question.saqAnswersList
      ?.filter(answer => answer.isChecked)
      .map(answer => answer.value);

    this.question.saqPossibleAnsers = checkedAnswers?.join('|') || '';
  }
}
function GetQuestionType(examinationTypeenum: string): string {
  switch (examinationTypeenum) {
    case 'MultipleChoice':
      return 'OptionsOnly';
    case 'Essay':
      return 'Essay';
    case 'SAQ':
      return 'SAQ';
    default: 'NotSet'
  }
}

